import { path, formatTime } from '@/scripts/tools/utils';
import mime from 'mime';
import _ from 'lodash';
import EditorDataBase from './dbTools';

const editorHistoryDB = new EditorDataBase();
/**
 * 检查连续 2 个字符出现次数
 * @param {String} str
 */
function checkRepeat(str) {
  str = str.replace(/\s*/g, '');

  let chars = ''; // 连续字符串
  const init = str.charAt(0); // 初始值
  const frequencyMap = {};
  let count = 0;

  Array.from(str).reduce((prev, cur) => {
    // 判断是否为连续字符
    if (prev === cur) {
      chars += prev;
      if (chars.length > 1) {
        if (chars) {
          frequencyMap[chars] ? frequencyMap[chars]++ : (frequencyMap[chars] = 1);
          count++;
        }
        chars = cur;
      }
    } else {
      chars = cur;
    }
    return cur;
  }, init);

  return { frequencyMap, count };
}

const monaco = require('monaco-editor');

const supportLanguages = monaco.languages.getLanguages();
const MaxCheckLen = 2 * 1024 * 1024;

const tools = {
  languageList: (() => supportLanguages.map(language => language.id))(),
  getMimeType(key) {
    const extname = path.extname(key);
    const suffix = extname.slice(1);
    if (!extname) return 'plaintext';

    let languageId = '';
    for (let i = 0; i < supportLanguages.length; i++) {
      const language = supportLanguages[i];
      if (language.extensions.includes(extname)) {
        languageId = language.id;
        break;
      }
    }

    if (!languageId) {
      let hasText = false;
      try {
        hasText = mime.getType(key).startsWith('text');
      } catch (error) {
        // console.log('[getMimeType error]', error);
      }
      hasText && (languageId = 'plaintext');
    }

    if (!languageId) {
      const langMap = {
        plaintext: 'm3u8',
      };
      _.each(langMap, (item, langId) => {
        if (item.split(',').some(s => s === suffix)) languageId = langId;
      });
    }
    return languageId;
  },
  async saveFileToLocal(key, buffer) {
    const timestamp = Date.now();
    editorHistoryDB.add({ timestamp, name: key, content: buffer });
  },
  handleHistoryFiles() {
    return new Promise(resolve => {
      editorHistoryDB.getAll().then(list => {
        list = list
          .map(f => {
            const ctime = formatTime(f.timestamp);
            return {
              name: f.name,
              ctime,
              timestamp: f.timestamp,
            };
          })
          .sort((a, b) => b.timestamp - a.timestamp);
        resolve(list);
      });
    });
  },
  getHistoryFileByTime(timestamp) {
    return editorHistoryDB.get(timestamp);
  },
  deleteHistoryByTime(timestamp) {
    return editorHistoryDB.delete(timestamp);
  },
  clearHistory() {
    return editorHistoryDB.clear();
  },
  hasGarbled(str) {
    /**
     * 黑名单：
     * 1. \uD800-\uF8FF 高位替代字符,高位专用替代字符,低位专用字符,私用区字符
     * 2. \uFFF0−\uFFFF 特殊字符字符
     * 3. \uE0000-... 标签等其他超出范围的
     */

    /**
     * 由此推出白名单:
     * 1. \s
     * 2. \u0020-\uD7FF
     * 3. \uF900-\uFFEF
     * 4. \u10000-\udFFFF
     */
    let result = /[^\u0020-\uD7FF\uF900-\uFFEF\u10000-\udFFFF\s]+/.test(str);
    if (result) return result;

    // 检测字符串中连续重复次数大于1的码字，若连续重复率大于某个阈值，则认为中间有乱码
    const limitLen = str.length < MaxCheckLen ? str.length : MaxCheckLen;
    const res = checkRepeat(str.substring(0, limitLen));
    const { frequencyMap } = res;

    const freqSort = Object.keys(frequencyMap).sort((a, b) => frequencyMap[b] - frequencyMap[a]);

    if (freqSort.includes('??')) {
      const freq = frequencyMap['??'] / res.count;
      freq > 0.1 && freq < 0.5 && (result = true);
    }

    return result;
  },
};

export default tools;
